// extracted by mini-css-extract-plugin
module.exports = {"svgB":"style_svgB__NipVq"};